import type { LiveState } from '@models/api';
import { LIVE_POLL_COPY } from '../livePollCopy';
import { PlaceLogo } from './BigScreenParts';

/**
 * E8b: the post was deleted or removed while live (TECH-867 § Errors; RESOLUTIONS L17). Names the join Space
 * (the removed state carries it, BE-L2b); an Event with no Space has none, so the line stops at thanks.
 */
export function BigScreenRemoved({ state }: { state: LiveState }) {
  const space = state.join_space?.name ?? (state.place.type === 'space' ? state.place.name : null);
  const tile = state.join_space ?? state.place;
  return (
    <div
      className="flex h-full w-full flex-col items-start justify-center gap-5 overflow-hidden bg-mb-bg px-[120px]"
      data-testid="big-screen-removed"
    >
      <PlaceLogo
        name={tile.name}
        imageUrl={tile.image_url}
        className="h-[72px] w-[72px] rounded-2xl"
        initialsClassName="text-[26px] leading-[30px]"
      />
      <h1 className="font-livvic text-[64px] font-bold leading-[70px] tracking-[-0.015em] text-mb-ink">
        {LIVE_POLL_COPY.removedTitle}
      </h1>
      <p className="w-[820px] max-w-full font-fira text-[26px] font-normal leading-[34px] text-mb-gray-dark">
        {LIVE_POLL_COPY.removedLine(space)}
      </p>
    </div>
  );
}
